import * as PIXI from "pixi.js";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class KarenTextStyles {
    public static MULTIPLIER_TEXT_STYLE: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "Impact",
        fontSize: "26.5px",
        "fill": [
            "#fe543b",
            "#f63b34",
            "#e9240f"
        ],
    });

    public static INFECTIOUS_MULTIPLIER_TEXT_STYLE: PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily: "Impact",
        fontSize: "26.5px",
        "fill": [
            "#b24acf",
            "#a421b5"
        ],
    });

    public static WAYS_TEXT_COUNTUP_STYLE: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontStyle: FontStyle.ITALIC,
        fontSize: 30,
        fontWeight: FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 8,
        fill: "#FFFFFF",
        lineJoin: "round",
        align: "center",
        stroke: "#FF2600",
        strokeThickness: 8
    };
}
